export default "__VITE_ASSET__CIWYIS$1__"